import { render, staticRenderFns } from "./IpRangesTabStorage.vue?vue&type=template&id=4ef7a0c4&scoped=true&"
import script from "./IpRangesTabStorage.vue?vue&type=script&lang=js&"
export * from "./IpRangesTabStorage.vue?vue&type=script&lang=js&"
import style0 from "./IpRangesTabStorage.vue?vue&type=style&index=0&id=4ef7a0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7a0c4",
  null
  
)

export default component.exports